import { render, staticRenderFns } from "./MultiCreateControl.vue?vue&type=template&id=639c796e&scoped=true&"
import script from "./MultiCreateControl.vue?vue&type=script&lang=ts&"
export * from "./MultiCreateControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c796e",
  null
  
)

export default component.exports